// extracted by mini-css-extract-plugin
module.exports = {"header":"_22Gu1a3iNOjbRIMZlztEv5","title":"_1ZxKIZRH4SHIkiIy-su25t","dialog":"_24vziHPNBvdWWrsxqm3OON","role":"_2HCX34nd04qG5mlSsBZ7AJ","dialogBody":"_2zXcfD6IWDcRWyiSDvG-5n"};